import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    ActionType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_2231_payroll_summary: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Payroll",
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                childComponents: [
                    {
                        componentType: LayoutTypes.GROUP,
                        style: {
                            direction: FlexDirection.ROW,
                            justifyContent: "flex-end",
                            marginBottom: 16,
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.BUTTON,
                                name: "run_payroll",
                                Label: "Run Payroll",
                                onPressAction: "run_payroll",
                                style: {
                                    backgroundColor: "var(--primary-green)",
                                    textColor: "#FFFFFF",
                                    padding: 12,
                                    borderRadius: 6,
                                    fontSize: 14,
                                    fontWeight: "500",
                                },
                            },
                        ],
                    },
                    {
                        componentType: ComponentType.INFO_CARDS,
                        apiname: "/pabws/hrms/payroll/statistics",
                        cards: [
                            {
                                name: "Total Payout",
                                bindValue: "total_payout",
                                color: "#ffffff",
                                defaultValue: "0.00",
                                valueFormat: "currency",
                                icon: "💰",
                            },
                            {
                                name: "Pending Approvals",
                                bindValue: "pending_approvals",
                                color: "#ffffff",
                                defaultValue: 0,
                                valueFormat: "number",
                                icon: "⏳",
                            },
                            {
                                name: "Employees Processed",
                                bindValue: "employees_processed",
                                color: "#ffffff",
                                defaultValue: "0/0",
                                valueFormat: "text",
                                icon: "👥",
                            },
                        ],
                    },
                    {
                        componentType: LayoutTypes.GROUP,
                        style: {
                            backgroundColor: "hsl(var(--bg-white))",
                            padding: 20,
                            marginTop: 16,
                            borderRadius: 4,
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.CUSTOM,
                                customType: "monthFilter",
                                name: "payroll_month_filter",
                                props: {
                                    filterField: "payroll_month",
                                },
                            },
                            {
                                componentType: ComponentType.SUMMARY_LIST,
                                DisplayName: "Employee Payroll",
                                Name: "payroll_summary",
                                apiname: "payroll_summary",
                                titleValue: "employee_name",
                                TableName: "employee",
                                View: "view_payroll_summary",
                                fields: [
                                    {
                                        IncludeLabel: true,
                                        Label: "Employee",
                                        BindValue: "employee_name",
                                        Json_Attribute: "employee_name",
                                        componentType: ComponentType.TEXT_FIELD,
                                        showInSummary: true,
                                        // custom props not in type def but might be used by component
                                        // showEmployeeAvatar: true,
                                        // showEmployeeId: true
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Department",
                                        BindValue: "department_name",
                                        Json_Attribute: "department_name",
                                        componentType: ComponentType.TEXT_FIELD,
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Gross Pay",
                                        BindValue: "gross_earnings",
                                        Json_Attribute: "gross_earnings",
                                        componentType: ComponentType.TEXT_FIELD,
                                        // valueFormat: "currency",
                                        showInSummary: true,
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Deductions",
                                        BindValue: "total_deductions",
                                        Json_Attribute: "total_deductions",
                                        componentType: ComponentType.TEXT_FIELD,
                                        // valueFormat: "currency",
                                        showInSummary: true,
                                        // negativeColor: true
                                    },
                                    {
                                        IncludeLabel: true,
                                        Label: "Status",
                                        BindValue: "calculation_status",
                                        Json_Attribute: "calculation_status",
                                        componentType: ComponentType.TEXT_FIELD,
                                        showInSummary: true,
                                        // statusPill: true
                                    },
                                ],
                                SummeryActions: [
                                    {
                                        ActionType: "view_details",
                                        Label: "View",
                                        Action: {
                                            Action: "Navigate",
                                            Navigate: "hrm/payslip_view/<id>",
                                        },
                                        visibility: [1, 2],
                                    },
                                    {
                                        Action: {
                                            Action: "Navigate",
                                            Navigate: "hrm/payroll_employee_edit/<id>",
                                        },
                                        ActionType: "Edit",
                                        visibility: [1, 2],
                                    },
                                    {
                                        Action: {
                                            Action: "Delete",
                                            Module: "payroll_employee",
                                        },
                                        ActionType: "Delete",
                                        visibility: [1],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
